import React from 'react';

interface CalendarIconProps {
  className?: string;
  size?: number;
}

export const CalendarIcon: React.FC<CalendarIconProps> = ({ className = "", size = 17 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 17 17" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_16604_31682)">
        <path 
          d="M5.56665 1.4541V4.16243" 
          stroke="#00C49A" 
          strokeWidth="1.35" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M10.9833 1.4541V4.16243" 
          stroke="#00C49A" 
          strokeWidth="1.35" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M13.0145 2.80835H3.53538C2.78749 2.80835 2.18121 3.41463 2.18121 4.16252V13.6417C2.18121 14.3896 2.78749 14.9958 3.53538 14.9958H13.0145C13.7624 14.9958 14.3687 14.3896 14.3687 13.6417V4.16252C14.3687 3.41463 13.7624 2.80835 13.0145 2.80835Z" 
          stroke="#00C49A" 
          strokeWidth="1.35" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
        <path 
          d="M2.18121 6.87085H14.3687" 
          stroke="#00C49A" 
          strokeWidth="1.35" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_16604_31682">
          <rect width="16.25" height="16.25" fill="white" transform="translate(0.149963 0.0999756)"/>
        </clipPath>
      </defs>
    </svg>
  );
};
